export default `<!DOCTYPE html>
<html lang="th">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>ประกาศความเป็นส่วนตัวสำหรับการบันทึกเสียงในการสอบ</title>
    <style>
        body {
            font-family: Arial, "Noto Sans Thai", Tahoma, sans-serif;
            line-height: 1.8;
            margin: 0;
        }
        h2 {
            text-align: center;
            font-size: 20px;
            line-height: 1.6;
            margin-top: 40px;
            margin-bottom: 24px;
        }
        p {
            margin-bottom: 15px;
        }
        a {
            color: #0066cc;
            text-decoration: none;
        }
        a:hover {
            text-decoration: underline;
        }
        @media (max-width: 600px) {
            body { padding: 16px; }
            h2 { font-size: 19px; }
        }
    </style>
</head>
<body>
    <h2>ประกาศความเป็นส่วนตัวสำหรับการบันทึกเสียงในการสอบโดยใช้ปัญญาประดิษฐ์ (AI) ช่วยประมวลผล</h2>

    <p>การสอบความรู้เกี่ยวกับผลิตภัณฑ์ครั้งนี้จัดขึ้นโดย <strong>บริษัท เสียวหมี่ เทคโนโลยี (ประเทศไทย) จำกัด</strong> ("Xiaomi") ในระหว่างการสอบ ระบบ AI จะอ่านคำถามให้ผู้เข้าสอบฟัง และผู้เข้าสอบจะต้องตอบคำถามด้วยเสียงและ <strong>โต้ตอบกับ AI</strong> โดย AI จะจดจำและวิเคราะห์เนื้อหาคำตอบของผู้เข้าสอบเพื่อประมวลผลคะแนนสอบเบื้องต้น</p>

    <p>เพื่อจัดการและดำเนินการสอบ เราจะประมวลผลข้อมูลเกี่ยวกับท่านดังต่อไปนี้: <strong>รหัสพนักงาน ข้อมูลบัญชี Xiaomi และไฟล์บันทึกเสียงคำตอบของท่าน</strong> โดย AI จะให้คะแนนโดยอิงจากเนื้อหาคำตอบของท่านตามที่ปรากฏในไฟล์บันทึกเสียงเท่านั้น ทั้งนี้ AI จะไม่วิเคราะห์อารมณ์ ทัศนคติ ระดับความมั่นใจ สำเนียง หรือคุณลักษณะอื่นใดของเสียง การบันทึกเสียงจะถูกนำไปใช้เฉพาะเพื่อแปลงเสียงพูดเป็นข้อความ ให้คะแนนสอบ และตรวจสอบโดยเจ้าหน้าที่ด้วยตนเองเท่าที่จำเป็นเท่านั้น โดยจะไม่ถูกนำไปใช้เพื่อการฝึกอบรมโมเดลโมเดล AI หรือใช้เพื่อวัตถุประสงค์อื่นใด</p>

    <p><strong>รายละเอียดการประมวลผลข้อมูล</strong></p>

    <p>ในระหว่างการสอบ ระบบจะรวบรวมไฟล์บันทึกเสียงคำตอบของท่านและแปลงเสียงเป็นข้อความผ่านเซิร์ฟเวอร์ที่ตั้งอยู่ในสาธารณรัฐสิงคโปร์ เมื่อการสอบเสร็จสิ้น ไฟล์บันทึกเสียงจะถูกจัดเก็บไว้บนเซิร์ฟเวอร์ในสาธารณรัฐสิงคโปร์ ก่อนที่จะมีการโอนข้อมูลใด ๆ ไปยังสาธารณรัฐประชาชนจีน เซิร์ฟเวอร์ในสาธารณรัฐสิงคโปร์จะดำเนินการการลบข้อมูลที่สามารถระบุตัวตน (De-identification) โดยนำข้อมูลที่สามารถระบุตัวท่านได้โดยตรง เช่น ชื่อของท่าน ออกก่อน เพื่อทำให้ข้อมูลดังกล่าวไม่สามารถระบุตัวตนได้</p>

    <p>ข้อมูลที่ผ่านกระบวนการลบข้อมูลระบุตัวตนแล้ว ซึ่งประกอบด้วยรหัสชุดข้อสอบ (Exam Paper ID) และข้อความถอดเสียงจากไฟล์บันทึกเสียง จะถูกโอนไปยังเซิร์ฟเวอร์ในสาธารณรัฐประชาชนจีนเพื่อใช้ในการให้คะแนนโดยอัตโนมัติ ทั้งนี้ การให้คะแนนจะพิจารณาจากข้อความถอดเสียงเท่านั้น เมื่อการให้คะแนนเสร็จสิ้น เซิร์ฟเวอร์ในสาธารณรัฐประชาชนจีนจะส่งรหัสชุดข้อสอบและคะแนนที่เกี่ยวข้องกลับมายังเซิร์ฟเวอร์ในสาธารณรัฐสิงคโปร์ ซึ่งจะนำคะแนนดังกล่าวมาจับคู่กับข้อมูลระบุตัวตนของท่านโดยอ้างอิงจากรหัสชุดข้อสอบ</p>

    <p>ไฟล์บันทึกเสียงของท่านจะถูกเก็บรักษาไว้เป็นระยะเวลา 90 วันนับจากวันที่สรุปผลคะแนนสอบขั้นสุดท้าย และจะถูกลบเมื่อครบกำหนดระยะเวลาดังกล่าว</p>

    <p>หากท่านมีข้อสงสัยเกี่ยวกับคะแนนสอบ ท่านสามารถขอให้มีการตรวจสอบคะแนนด้วยตนเองได้โดยเลือกปุ่ม 【อุทธรณ์ (Appeal)】 เจ้าหน้าที่ผู้ได้รับอนุญาตของ Xiaomi จะตรวจสอบไฟล์บันทึกเสียงและข้อความถอดเสียงที่เกี่ยวข้องเพื่อดำเนินการทบทวนคะแนน ผลการสอบของท่านอาจถูกนำไปใช้เพื่อระบุความต้องการในการฝึกอบรมความรู้เกี่ยวกับผลิตภัณฑ์ และปรับปรุงการจัดฝึกอบรมที่เกี่ยวข้องให้เหมาะสมยิ่งขึ้น</p>

    <p>หากท่านไม่ยินยอมให้มีการบันทึกเสียง ท่านจะไม่สามารถเข้าสอบได้ หากท่านเคยให้ความยินยอมแล้วแต่ประสงค์จะถอนความยินยอมในการประมวลผลไฟล์บันทึกเสียงโดย Xiaomi ท่านสามารถติดต่อเราได้ที่ <a href="https://privacy.mi.com/support">https://privacy.mi.com/support</a> หากท่านถอนความยินยอมก่อนสอบเสร็จสิ้น ท่านจะไม่สามารถดำเนินการสอบต่อได้</p>

    <p>หากท่านประสงค์จะใช้สิทธิเกี่ยวกับข้อมูลส่วนบุคคลของท่าน รวมถึงสิทธิในการเข้าถึงและขอให้ลบข้อมูลส่วนบุคคล โปรดดูรายละเอียดได้ที่ <a href="https://privacy.mi.com/all/languages/">https://privacy.mi.com/all/languages/</a></p>

    <p><strong>การที่ท่านตกลงยอมรับประกาศความเป็นส่วนตัวฉบับนี้ ถือว่าท่านรับทราบว่าได้อ่านและเข้าใจรายละเอียดในประกาศฉบับนี้แล้ว และให้ความยินยอมในการบันทึกเสียงคำตอบของท่าน บันทึกถ้อยคำ การประมวลผลโดย AI เพื่อให้คะแนนสอบเบื้องต้น และการตรวจสอบโดยเจ้าหน้าที่ผู้ได้รับอนุญาตในกรณีที่จำเป็น ตามรายละเอียดที่ระบุไว้ในประกาศฉบับนี้</strong></p>
</body>
</html>`